// removed by extract-text-webpack-plugin
module.exports = {"verticalCenter":"verticalCenter___32L67"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layer/layer.less
// module id = 743
// module chunks = 3